import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import * as actions from '../../actions/historyActions';
import { modalController } from '../../actions/domActions';
import BaseModal from './BaseModal';
import MODAL_SETTINGS from '../../styles/modalSettings';
import * as dateUtils from '../../utils/date';

import './DateFilterPickerModal.scss';


function mapStateToProps (state) {
    return { isOpen: state.modal.isDateFilterPickerOpen };
}

function mapDispatchToProps (dispatch) {
    return {
        closeModal: () => dispatch(modalController('CLOSE_ALL')),
        setStartDate: (date) => dispatch(actions.setHistoryStartDate(date)),
        unsetStartDate: (date) => dispatch(actions.unsetHistoryStartDate(date)),
        setEndDate: (date) => dispatch(actions.setHistoryEndDate(date)),
        unsetEndDate: (date) => dispatch(actions.unsetHistoryEndDate(date)),
        refreshEntries: () => dispatch(actions.refreshEntries())
    };
}

class DateFilterPickerModal extends Component {
    constructor () {
        super();
        this.state = {
            startEnabled: true,
            startDate: moment(),
            endEnabled: false,
            endDate: moment()
        };
    }

    _handleStartChange (val) {
        const newState = { startDate: val };
        if (val > this.state.endDate) {
            newState.endDate = val;
        }
        this.setState(newState);
    }

    _handleEndChange (val) {
        const newState = { endDate: val };
        if (val < this.state.startDate) {
            newState.startDate = val;
        }
        this.setState(newState);
    }

    _handleButtonClick () {
        if (this.state.startEnabled) {
            this.props.setStartDate(dateUtils.dateToApiString(this.state.startDate));
        } else {
            this.props.unsetStartDate();
        }
        if (this.state.endEnabled) {
            this.props.setEndDate(dateUtils.dateToApiString(this.state.endDate));
        } else {
            this.props.unsetEndDate();
        }
        this.props.refreshEntries();
        this.props.closeModal();
    }

    render () {
        let startPickerProps = {};
        let endPickerProps = {};

        if (this.state.startEnabled && this.state.endEnabled) {
            startPickerProps = {
                startDate: this.state.startDate,
                endDate: this.state.endDate,
                selectsStart: true
            };
            endPickerProps = {
                startDate: this.state.startDate,
                endDate: this.state.endDate,
                selectsEnd: true
            };
        }

        return (
            <BaseModal
                isOpen={this.props.isOpen}
                hasCloseButton={true}
                renderWithHeader={true}
                title='Limit time entries to...'
                shouldCloseOnOverlayClick={false}
                onRequestClose={() => this.props.closeModal()}
                containerClass="defaultModal date-filter-picker-modal"
                style={{ content: { ...MODAL_SETTINGS.content, maxWidth: 400 } }}
            >
                <div className="container-fluid">
                    <div className="date-filter-picker input-fields">
                        <div className="row">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={this.state.startEnabled}
                                    onChange={() => this.setState({ startEnabled: !this.state.startEnabled })}
                                />
                                &nbsp;
                                <strong>Starting on</strong>
                            </label>
                            <br/>
                            <div className="col-md-12">
                                <DatePicker
                                    disabled={!this.state.startEnabled}
                                    className="dateInput"
                                    selected={this.state.startDate}
                                    onChange={(val) => this._handleStartChange(val)}
                                    showYearDropdown
                                    {...startPickerProps}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={this.state.endEnabled}
                                    onChange={() => this.setState({ endEnabled: !this.state.endEnabled })}
                                />
                                &nbsp;
                                <strong>Ending on</strong>
                            </label>
                            <div className="col-md-12">
                                <DatePicker
                                    disabled={!this.state.endEnabled}
                                    className="dateInput"
                                    selected={this.state.endDate}
                                    onChange={(val) => this._handleEndChange(val)}
                                    showYearDropdown
                                    {...endPickerProps}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 text-right">
                                <button
                                    disabled={!this.state.endEnabled && !this.state.startEnabled}
                                    className="btn btn-default"
                                    onClick={() => this._handleButtonClick()}
                                >
                                    Filter
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </BaseModal>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DateFilterPickerModal);



// WEBPACK FOOTER //
// ./app/components/Modals/DateFilterPickerModal.jsx